import { styled } from '@mui/material/styles'

export const Container = styled('div')({
  position: 'relative',
  width: '100%',
})

export const NotesMainContainer = styled('div')({
  flex: 1,
  background: '#FFFFFF',
  overflow: 'auto',
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column',
})

export const NotesWrapper = styled('div')({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: 'calc(100vh - 152px)',
})

export const NotesListContainer = styled('div')({
  flex: 1,
  background: '#FFFFFF',
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '170px',

  '& > div': {
    width: '100%',
  },
})

export const SkeletonWrapper = styled('div')(({ theme }) => ({
  background: theme.palette.background.default,
  width: '100%',
  margin: '10px 0px',
  padding: 20,
}))

export const InputWrapper = styled('div')({
  height: 100,
  width: '100%',
  position: 'absolute',
  zIndex: 100,
  bottom: 52,
  backgroundColor: 'white',
})
